<template>
  <path
    d="M15.5 1.00018H7.5C6.12 1.00018 5 2.12018 5 3.50018V20.5002C5 21.8802 6.12 23.0002 7.5 23.0002H15.5C16.88 23.0002 18 21.8802 18 20.5002V3.50018C18 2.12018 16.88 1.00018 15.5 1.00018ZM11.5 22.0002C10.67 22.0002 10 21.3302 10 20.5002C10 19.6702 10.67 19.0002 11.5 19.0002C12.33 19.0002 13 19.6702 13 20.5002C13 21.3302 12.33 22.0002 11.5 22.0002ZM16 18.0002H7V4.00018H16V18.0002Z"
  />
</template>
